import { ASK_USER_QUESTION_TOOL_NAME, ASK_USER_QUESTIONS_TOOL_NAME } from 'breeze-engine-core/askUserQuestionSpec';
import { createCiteMarkerRegex, extractCiteId } from './citationUtils';

// Replace [cite-xxx] markers with the cited entity's title. Unknown markers are
// left intact so a missing title never silently deletes question context.
export function resolveCiteMarkersToTitles(text, citeToTitle) {
  if (citeToTitle.size === 0) return text;
  return text.replace(createCiteMarkerRegex(), match => {
    var _citeToTitle$get;
    const id = extractCiteId(match);
    return (_citeToTitle$get = citeToTitle.get(id)) !== null && _citeToTitle$get !== void 0 ? _citeToTitle$get : match;
  });
}
function isAskUserQuestionItem(value) {
  return typeof value === 'object' && value !== null && typeof value.question === 'string';
}
function isAskUserQuestionsInput(value) {
  return typeof value === 'object' && value !== null && Array.isArray(value.questions);
}
function resolveQuestionItem(item, citeToTitle) {
  const question = resolveCiteMarkersToTitles(item.question, citeToTitle);
  // possibleResponses is intentionally untouched: answer submission matches on
  // those exact option strings.
  return question === item.question ? item : Object.assign({}, item, {
    question
  });
}
function resolveToolInput(tool, citeToTitle) {
  if (tool.toolName === ASK_USER_QUESTION_TOOL_NAME && isAskUserQuestionItem(tool.input)) {
    return resolveQuestionItem(tool.input, citeToTitle);
  }
  if (tool.toolName === ASK_USER_QUESTIONS_TOOL_NAME && isAskUserQuestionsInput(tool.input)) {
    let changed = false;
    const questions = tool.input.questions.map(item => {
      if (!isAskUserQuestionItem(item)) return item;
      const resolved = resolveQuestionItem(item, citeToTitle);
      if (resolved !== item) changed = true;
      return resolved;
    });
    return changed ? Object.assign({}, tool.input, {
      questions
    }) : tool.input;
  }
  return tool.input;
}

// Resolve [cite-xxx] markers in AUQ tool-call question text. activeTools is
// reducer state that never passes through normalizeMessages/resolveCitations,
// so its question strings would otherwise render markers literally. Returns the
// original array (and original tool/input references) when nothing changed to
// preserve referential stability for useSyncExternalStore consumers.
export function resolveCiteMarkersInActiveTools(activeTools, citeToTitle) {
  if (citeToTitle.size === 0) return activeTools;
  let changed = false;
  const resolved = activeTools.map(tool => {
    const input = resolveToolInput(tool, citeToTitle);
    if (input === tool.input) return tool;
    changed = true;
    return Object.assign({}, tool, {
      input
    });
  });
  return changed ? resolved : activeTools;
}